<template>
  <el-dialog
    :title="$t('ExcelConfig.Title')"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="hide"
    destroy-on-close
  >
    <p>{{ $t('ExcelConfig.Import') }}</p>
    <div class="text">
      1.{{ $t('ExcelConfig.AfterDownload') }}<br />
      2.{{ $t('ExcelConfig.ImportExcel') }}
      <el-button type="primary" @click="onDownload">{{ $t('ExcelConfig.Download') }}</el-button><br />
      3.{{ $t('ExcelConfig.MustHave') }}<br />
      4.{{ $t('ExcelConfig.Supports') }}<br />
    </div>
    <div>
      <BjImportFile
        ref="BjImportFile"
        accept=".xls,.xlsx"
        :limit-size="128 * 1024"
        auto-upload
        @importFile="importFile"
      >
        <template #top> </template>
        <template slot="default"> {{ $t('ExcelConfig.maximum') }} </template>
      </BjImportFile>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('ExcelConfig.Confirm') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { importApi, commonApi, goodsApi } from '@/api';
import { downloadBlob } from '@/utils/index';
import papa from 'papaparse';

export default {
  data() {
    return {
      dialogVisible: false,
      file: null,
      skuList: null,
      barcodeList: null,
      downTemplateCode: null,
    };
  },
  created() {
    this.getTemplateCode()
  },
  methods: {
    getTemplateCode() {
      this.downTemplateCode = this.$store.getters.cusId ? 'SGOO.PACKAGE_IMPORT_CSG_USER' : 'SGOO.PACKAGE_IMPORT_CSG_ADMIN' ;
    },
    show() {
      this.file = null;
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    // 模版下载
    onDownload() {
      const data = {templateCode: this.downTemplateCode, tenantId: this.$store.getters.tenantId || 0};
      importApi['exportExcelImportTemplateHeaders'](data).then(res => {
        downloadBlob(res, `Package Import Template.xlsx`);
      });
    },
    isValidToTwo(str) {
      return !isNaN(str) && str > 0;
    },
    beforeVerify(dataList) {
      return new Promise((resolve, reject) => {
        let bstop = true;
        const skuMap = {};
        const barcodeMap = {};
        this.barcodeList = new Set();
        this.skuList = new Set();
        const reg = /^[`~!@#$%^&*()_+<>?":| {}\/\[\]\\\-+=,.\/;'*0-9A-Za-z]*$/;
        dataList.forEach(item => {
          item.errorTip = '';
          if (!item['Package Name']) {
            item.errorTip = `Package Name ${this.$t('emptyWarningText')}`;
            bstop = false;
            return;
          }
          if (!item['Package SKU']) {
            item.errorTip = `Package SKU ${this.$t('emptyWarningText')}`;
            bstop = false;
            return;
          }
          // 含空格验证
          if(/\s/.test(item['Package SKU'])){
            item.errorTip = `Package SKU ${this.$t('formatErrorText')}`;
            bstop = false;
            return;
          }
          // 格式验证
          if(!reg.test(item['Package SKU'])){
            item.errorTip = `Package SKU ${this.$t('formatErrorText')}`;
            bstop = false;
            return;
          }
          // 查重验证
          if (skuMap[item['Package SKU']]) { 
            item.errorTip = `Package SKU Duplication.`;
            bstop = false;
            return;
          }
          // if (!item['Package BarCode']) {
          //   item.errorTip = `Package BarCode ${this.$t('emptyWarningText')}`;
          //   bstop = false;
          //   return;
          // }
          // if (item['Package BarCode'] && (/[^a-zA-Z0-9_#\[\]\(\)\-]/g.test(String(item['Package BarCode'])) || String(item['Package BarCode']).length>14)) {
          //   item.errorTip = `Package BarCode ${this.$t('formatErrorText')}`;
          //   bstop = false;
          //   return;
          // }
          // if (item['Package BarCode'] && String(item['Package BarCode']).trim() && !this.barcodeList.has(item['Package BarCode'])) {
          //   this.barcodeList.add(String(item['Package BarCode']).trim());
          //   this.skuList.add(String(item['Package SKU']).trim());
          // }
          // if (item['Package BarCode'] && String(item['Package BarCode']).trim() && barcodeMap[item['Package BarCode']]) { // 如果sku已经存在
          //     item.errorTip = `Package BarCode duplication.`;
          //     bstop = false;
          //     return;
          // }
          // 需求迭代，暂时关闭'Packing Method'
          // if (!item['Packing Method']) {
          //   item.errorTip = `Packing Method ${this.$t('emptyWarningText')}`;
          //   bstop = false;
          //   return;
          // }
          // if(!['ORDER PACKAGING MATERIALS', 'PRODUCT PACKAGING MATERIALS'].includes(String(item['Packing Method']).toUpperCase())){
          //   item.errorTip = `Packing Method ${this.$t('formatErrorText')}`;
          //   bstop = false;
          //   return;
          // }

          // if (!item['Package Type']) {
          //   item.errorTip = `Package Type ${this.$t('emptyWarningText')}`;
          //   bstop = false;
          //   return;
          // }
          // if(!['CSG Packaging Materials', 'Customer Packaging Materials'].includes(String(item['Package Type']).toUpperCase())){
          //   item.errorTip = `Package Type ${this.$t('formatErrorText')}`;
          //   bstop = false;
          //   return;
          // }
          // if (!item['Supplier']) {
          //   item.errorTip = `Supplier ${this.$t('emptyWarningText')}`;
          //   bstop = false;
          //   return;
          // }
          if (!this.$store.getters?.cusId) {
            if (!item['Package Cost']) {
              item.errorTip = `Package Cost ${this.$t('emptyWarningText')}`;
              bstop = false;
              return;
            }
            if(!this.isValidToTwo(item['Package Cost'])){
              item.errorTip = `Package Cost ${this.$t('formatErrorText')}`;
              bstop = false;
              return;
            }
            if (!item['Package Price']) {
              item.errorTip = `Package Price ${this.$t('emptyWarningText')}`;
              bstop = false;
              return;
            }
            if(!this.isValidToTwo(item['Package Price'])){
              item.errorTip = `Package Price ${this.$t('formatErrorText')}`;
              bstop = false;
              return;
            }
          }
          if (!item['Length(CM)']) {
            item.errorTip = `Length(CM) ${this.$t('emptyWarningText')}`;
            bstop = false;
            return;
          }
          if(!this.isValidToTwo(item['Length(CM)'])){
            item.errorTip = `Length(CM) ${this.$t('formatErrorText')}`;
            bstop = false;
            return;
          }
          if (!item['Length(CM)']) {
            item.errorTip = `Length(CM) ${this.$t('emptyWarningText')}`;
            bstop = false;
            return;
          }
          if(!this.isValidToTwo(item['Length(CM)'])){
            item.errorTip = `Length(CM) ${this.$t('formatErrorText')}`;
            bstop = false;
            return;
          }
          if (!item['Width(CM)']) {
            item.errorTip = `Width(CM) ${this.$t('emptyWarningText')}`;
            bstop = false;
            return;
          }
          if(!this.isValidToTwo(item['Width(CM)'])){
            item.errorTip = `Width(CM) ${this.$t('formatErrorText')}`;
            bstop = false;
            return;
          }
          if (!item['Height(CM)']) {
            item.errorTip = `Height(CM) ${this.$t('emptyWarningText')}`;
            bstop = false;
            return;
          }
          if(!this.isValidToTwo(item['Height(CM)'])){
            item.errorTip = `Height(CM) ${this.$t('formatErrorText')}`;
            bstop = false;
            return;
          }
          if (!item['Weight(KG)']) {
            item.errorTip = `Weight(KG) ${this.$t('emptyWarningText')}`;
            bstop = false;
            return;
          }
          if(!this.isValidToTwo(item['Weight(KG)'])){
            item.errorTip = `Weight(KG) ${this.$t('formatErrorText')}`;
            bstop = false;
            return;
          }
        });

        resolve(bstop ? [] : dataList);
      });
    },
    importFile(file) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = () => {
        const buffer = reader.result;
        const bytes = new Uint8Array(buffer);
        const length = bytes.byteLength;
        let binary = '';
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        const XLSX = require('xlsx');
        const wb = XLSX.read(binary, { type: 'binary' });
        const excelList = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
        this.beforeVerify(excelList).then(dataList => {
          if ([...this.barcodeList].length > 0) {
            goodsApi.checkBarCode({barCode: [...this.barcodeList], skuCode: [...this.skuList]}).then(res => {
              if (!res.failed) {
                // this.afterUpload(dataList, file);
                goodsApi.checkSkuCode({barCode: [...this.barcodeList], skuCode: [...this.skuList]}).then(res => {
                  if (!res.failed) {
                    this.afterUpload(dataList, file);
                  }
                });
              }
            });
          } else {
            this.afterUpload(dataList, file);
          }
        });
      };
    },
    afterUpload(dataList, file) {
      if (dataList.length > 0) {
        this.$confirm(`${this.$t('ExcelConfig.excelEroorTip1')}<br>${this.$t('ExcelConfig.excelEroorTip2')}<br>${this.$t('ExcelConfig.excelEroorTip3')}`, this.$t('toast.hintText'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('downloadText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        }).then(() => {
          const csvData = [];

          dataList.forEach(item => {
            csvData.push({
              'Package Name': item['Package Name'],
              'Package SKU': item['Package SKU'],
              'Package BarCode': item['Package BarCode'],
              // 'Packing Method': item['Packing Method'],
              // 'packageType': item['Package Type'],
              // 'cusId': item['Supplier'],
              'Package Cost': item['Package Cost'],
              'Package Price': item['Package Price'],
              'Length(CM)': item['Length(CM)'],
              'Width(CM)': item['Width(CM)'],
              'Height(CM)': item['Height(CM)'],
              'Weight(KG)': item['Weight(KG)'],
              'error': item.errorTip
            });
          });
          csvData.forEach(item => {
            if (this.$store.getters?.cusId) {
              // delete item['Supplier'];
              delete item['Package Cost'];
              delete item['Package Price'];
            }
          });
          const csv = papa.unparse(csvData);
          const data = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
          const csvURL = window.URL.createObjectURL(data);
          const download = document.createElement('a');
          document.body.appendChild(download);
          download.href = csvURL;
          download.setAttribute('download', 'SKU import template');
          download.click();
          document.body.removeChild(download);
        });
      } else {
        this.file = file;
      }
    },
    confirm() {
      if (this.file) {
        commonApi.autoImport({
          prefix: 'sgoo',
          excel: this.file,
          templateCode: this.downTemplateCode,
        }).then(() => {
          this.$message.success(this.$t('toast.operationSuccessText'))
          this.hide();
          setTimeout(() => {
            this.$emit('submit');
          }, 1000);
        });
      } else {
        this.$message({
            message: this.$t('ExcelConfig.upload'),
            type: 'warning',
            duration: 5000,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  font-size: 12px;
  line-height: 2;
}
</style>
